module.exports = __webpack_public_path__ + "static/media/about.8fd6b28b.jpg";